
<div class="query-strip-container mat-elevation-z2">
  	<table height="100%"  width="100%" >
		<TR> 
			<TD class="table-title-cell"><i class="fa fa-cog table-icon-header" style="width: 2em"></i>{{formTitle}}</TD>
		</TR>
	</table>
</div>

<div id="parent">
    <div class="vertical-halves">
        <div>
            <div class="modules-div" *ngIf="visibleBanner"><app-banner #banner></app-banner></div>
            <div class="modules-div" *ngIf="visibleIntegration"><app-integration #integration></app-integration></div>
            <div class="modules-div" *ngIf="visibleAutomatch"><app-automatch #automatch></app-automatch></div>
        </div>
        <mat-divider vertical="true" style="padding-left: 21px;"></mat-divider>
    </div>

   <div class="vertical-halves"
        style="margin-left: 40px; width:100%;">
     <div class="rhs-module">
<!--          <event-messages #eventmessages></event-messages> -->
		<div class="modules-div" *ngIf="visibleSurveyMessages"><app-survey-emails #surveyemail></app-survey-emails></div>
		<div class="modules-div" *ngIf="visibleAutoClose"><app-auto-close #autoclose></app-auto-close></div>
		<div class="modules-div" *ngIf="visibleUnassignedEmails"><app-unassigned-request-emails #unassignedemails></app-unassigned-request-emails></div>
     </div>
   </div>
</div>

